"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _Vector = _interopRequireDefault(require("ol/layer/Vector.js"));
var _Feature = _interopRequireDefault(require("ol/Feature.js"));
var _Point = _interopRequireDefault(require("ol/geom/Point.js"));
var _Projection = _interopRequireDefault(require("ol/proj/Projection.js"));
var _Vector2 = _interopRequireDefault(require("ol/source/Vector.js"));
var _Cluster = _interopRequireDefault(require("ol/source/Cluster.js"));
var _Style = _interopRequireDefault(require("ol/style/Style.js"));
var _Icon = _interopRequireDefault(require("ol/style/Icon.js"));
var _Text = _interopRequireDefault(require("ol/style/Text.js"));
var _Fill = _interopRequireDefault(require("ol/style/Fill.js"));
var _Stroke = _interopRequireDefault(require("ol/style/Stroke.js"));
var _GeoJSON = _interopRequireDefault(require("ol/format/GeoJSON.js"));
var _groupBy = _interopRequireDefault(require("lodash/groupBy"));
var _sortBy = _interopRequireDefault(require("lodash/sortBy"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _take = _interopRequireDefault(require("lodash/take"));
var _partition3 = _interopRequireDefault(require("lodash/partition"));
var _helpers = require("./helpers");
var _map = require("../map");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } // import ol from "openlayers";
var statusColorKey = {
  'complete': "#000000",
  'unassigned': "#BDC3C7",
  'assigned': "#2ecc71",
  'due-soon': "#f1c40f",
  'overdue': "#e74c3c"
};
var taskStatusOrder = ["complete", "unassigned", "assigned", "due-soon", "overdue"];
var getTaskStatus = function getTaskStatus(task) {
  //remove timezone indicator
  var dueBy = (0, _moment["default"])(task.dueBy);
  var now = (0, _moment["default"])();
  var status;
  if (task.isComplete) {
    status = "complete";
  } else if (now.diff(dueBy, "minutes") >= 5) {
    status = "overdue";
  } else if (now.diff(dueBy, "minutes") > -15) {
    status = "due-soon";
  } else if (task.assignee) {
    status = "assigned";
  } else {
    status = "unassigned";
  }
  return status;
};
var getTaskFeatureStatus = function getTaskFeatureStatus(features) {
  var status = 'complete';
  var nextStatus = null;
  var task = null;
  features.forEach(function (feature, idx) {
    task = feature.get('task');
    nextStatus = getTaskStatus(task);
    if (taskStatusOrder.indexOf(nextStatus) > taskStatusOrder.indexOf(status)) {
      status = nextStatus;
    }
  });
  return status;
};
var mapTask = function mapTask(task, collections) {
  var features = (0, _helpers.getFeaturesFromObject)(task, collections);
  features.forEach(function (feature) {
    feature.set("task", task);
    feature.setId("task-" + task.taskId);
  });
  return features;
};
var styleCache = {};
var styleTask = function styleTask(feature, resolution) {
  var features = feature.get('features');
  var size = features.length;
  var status = getTaskFeatureStatus(features);
  var fillColor = statusColorKey[status];
  var key = size + '_' + fillColor;
  var style = styleCache[key];
  if (!style) {
    style = [new _Style["default"]({
      image: new Circle({
        radius: 10,
        stroke: new _Stroke["default"]({
          color: '#fff'
        }),
        fill: new _Fill["default"]({
          color: fillColor
        })
      }),
      text: new _Text["default"]({
        text: size.toString(),
        fill: new _Fill["default"]({
          color: '#fff'
        })
      })
    })];
    styleCache[key] = style;
  }
  return style;
};
var layer = new _Vector["default"]({
  style: styleTask,
  name: "tasks"
});

// ensure the tasks layer isn't obscured by the incident layer
layer.setZIndex(1000);
_map.map.addLayer(layer);
var tasks = {
  handleUpdate: function handleUpdate(_ref) {
    var layers = _ref.layers,
      tasks = _ref.tasks,
      mileposts = _ref.mileposts,
      locations = _ref.locations,
      milepostGroups = _ref.milepostGroups;
    return function (tasks) {
      //early cutoff for when layer is not visible or unavailable
      if (!(layers !== null && layers !== void 0 && layers.tasks) || (0, _isEmpty["default"])(tasks) || (0, _isEmpty["default"])(milepostGroups)) return;
      var _partition = (0, _partition3["default"])(mileposts, function (m) {
          return m.isStation;
        }),
        _partition2 = _slicedToArray(_partition, 2),
        stations = _partition2[0],
        milepostsWithoutStations = _partition2[1];
      var collections = {
        mileposts: milepostsWithoutStations,
        stations: stations,
        locations: locations,
        milepostGroups: milepostGroups
      };
      var features = [];
      var grouped = (0, _groupBy["default"])(tasks, 'scheduleId');
      for (var scheduleId in grouped) {
        var tasks = grouped[scheduleId];
        if (scheduleId == "null" || !tasks[0].doesRepeat) {
          //not repeating tasks, map all of them (ie normal and predecessor tasks)
          tasks.forEach(function (task) {
            features = features.concat(mapTask(task, collections));
          });
        } else {
          //repeating task, only map the latest un-completed task
          var sorted = (0, _sortBy["default"])(tasks, ['dueBy', 'taskId']);
          var task = {};
          for (var i = 0; i < sorted.length; i++) {
            //find the first uncompleted task
            if (!sorted[i].isComplete) {
              task = sorted[i];
              break;
            }
          }
          features = features.concat(mapTask(task, collections));
        }
      }
      var source = new _Vector2["default"]({
        features: features
      });
      var cluster = new _Cluster["default"]({
        distance: 40,
        source: source
      });
      layer.setVisible(layers === null || layers === void 0 ? void 0 : layers.tasks);
      layer.setSource(cluster);
    }(tasks);
  },
  getOverlay: function getOverlay(tasks, position, TaskButtonComponent) {
    _map.overlay.setPosition(position);
    tasks = (0, _sortBy["default"])(tasks, function (task) {
      return task.dueBy;
    });
    var buttons = (0, _take["default"])(tasks, 5).map(function (task) {
      return /*#__PURE__*/_react["default"].createElement(TaskButtonComponent, {
        key: task.taskId,
        task: task
      });
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "overlay-content",
      style: {
        padding: '10px'
      }
    }, buttons, tasks.length > 5 && /*#__PURE__*/_react["default"].createElement("span", null, tasks.length - 5, " more"));
  }
};
var _default = tasks;
exports["default"] = _default;